import {
  CurrencyValue,
  LineChart,
  formatNumber,
  InfinityIcon,
  formatCurrency
} from '@blockanalitica/ui';
import {
  SimpleChartData,
  SimpleChartDataset
} from '@blockanalitica/ui/package/types/src/components/charts/SimpleChart';
import { useCallback, useMemo } from 'react';
import { useTheme } from 'styled-components';
import { useChartFillDatasetsDates } from '@/hooks';

export default function HistoricGraphs({
  data,
  type,
  chartDaysAgo
}: {
  data: SimpleChartData[];
  type: string;
  chartDaysAgo: string;
}) {
  const theme = useTheme();
  const [datasets] = useMemo(() => {
    const datasets: SimpleChartDataset[] = [
      {
        xField: 'date',
        yField: type
      }
    ];
    const chartType: string = 'line';

    return [datasets, chartType];
  }, [type]);

  const valueFormatter = useCallback(
    (value: string | number) => {
      if (type === 'health_rate') {
        return (
          <CurrencyValue
            value={value}
            options={{
              nullable: '-',
              infinityThreshold: 1000,
              infinityIcon: (
                <InfinityIcon
                  width={theme.sizes['6']}
                  height={theme.sizes['4']}
                />
              )
            }}
          />
        );
      } else {
        return <CurrencyValue value={value} options={{ currency: 'USD' }} />;
      }
    },
    [type, theme.sizes]
  );

  const yScaleValueFormatter = useCallback(
    (value: string | number) => {
      if (type === 'health_rate') {
        return formatNumber(Number(value), { maximumFractionDigits: 5 });
      }
      return formatCurrency(Number(value), { maximumFractionDigits: 5 });
    },
    [type]
  );
  const fillValue = type === 'health_rate' ? null : 0;
  const chartData = useChartFillDatasetsDates(
    data,
    datasets,
    chartDaysAgo,
    fillValue
  );
  return (
    <LineChart
      key={type}
      data={chartData}
      datasets={datasets}
      valueFormatter={valueFormatter}
      yScaleValueFormatter={yScaleValueFormatter}
      daysAgo={chartDaysAgo}
    />
  );
}
